"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomInput = exports.Sizes = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var focus = ui_blocks_1.INTERACTIVE.focus,
    isDisabled = ui_blocks_1.INTERACTIVE.isDisabled;
var field = ui_blocks_1.FORM.field,
    hasErrors = ui_blocks_1.FORM.hasErrors; // Sizes =======================================================================

var Sizes;

(function (Sizes) {
  Sizes[Sizes["small"] = 4] = "small";
  Sizes[Sizes["medium"] = 5] = "medium";
})(Sizes = exports.Sizes || (exports.Sizes = {}));

var makeSizeStyles = function makeSizeStyles(size) {
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n"], ["\n  height: ", ";\n"])), (0, ui_symbols_1.calcSpace)(Sizes[size]));
};

var hasErrorsStyles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), hasErrors);
exports.CustomInput = styled_components_1.default.button(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  appearance: none;\n  height: 100%;\n  width: 100%;\n  text-align: left;\n  padding: 0 0 0 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.25rem;\n\n  > div {\n    vertical-align: text-bottom;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  appearance: none;\n  height: 100%;\n  width: 100%;\n  text-align: left;\n  padding: 0 0 0 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.25rem;\n\n  > div {\n    vertical-align: text-bottom;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), field, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeSizeStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'hasErrors', hasErrorsStyles);
}, function (_a) {
  var inFocus = _a.inFocus;
  return inFocus && focus;
}, function (_a) {
  var disabled = _a.disabled;
  return disabled && isDisabled;
});
var templateObject_1, templateObject_2, templateObject_3;